"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateOptions = void 0;
const createValidator = (validate, expectedType, overrideReceivedType) => (val) => {
    const receivedType = overrideReceivedType ? overrideReceivedType(val) : typeof val;
    return validate(val)
        ? { isValid: true }
        : {
            isValid: false,
            error: `The value '${val}' is of type ${receivedType}. Expected ${expectedType}`,
        };
};
const isBoolean = createValidator((val) => typeof val === 'boolean', 'boolean');
const isString = createValidator((val) => typeof val === 'string', 'string');
const isNumber = createValidator((val) => typeof val === 'number', 'number');
const isDate = createValidator((val) => val instanceof Date, 'Date');
const isUnionOf = (options) => createValidator((val) => options.includes(val), `[${options.join(' | ')}]`, (val) => `[${val}]`);
const validCookieOptions = [
    { name: 'expires', isValid: isDate },
    { name: 'maxAge', isValid: isNumber },
    { name: 'domain', isValid: isString },
    { name: 'path', isValid: isString },
    { name: 'secure', isValid: isBoolean },
    { name: 'httpOnly', isValid: isBoolean },
    { name: 'sameSite', isValid: isUnionOf(['Strict', 'Lax']) },
];
const validateOptions = (options) => Object.entries(options)
    .map(([key, value]) => {
    const optionValidator = validCookieOptions.find((option) => option.name === key);
    const validation = optionValidator
        ? optionValidator.isValid(value)
        : {
            isValid: false,
            error: `Option '${key}' is not supported`,
        };
    return {
        name: key,
        value,
        ...validation,
    };
})
    .reduce((acc, cur) => ({
    isValid: acc.isValid && cur.isValid,
    errors: cur.error ? [...acc.errors, cur.error] : acc.errors,
}), { errors: [], isValid: true });
exports.validateOptions = validateOptions;
//# sourceMappingURL=validation.js.map